import { FileError } from "./file-error";

export class UserFile {
  blob: Blob;
  file: File;
  fileErrors = new Array<FileError>();
}